<template>
	<div>
		<svg
			:width="iconSize"
			:height="iconSize"
			viewBox="0 0 25 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M15.625 10.9375C15.625 12.6634 14.2259 14.0625 12.5 14.0625C10.7741 14.0625 9.375 12.6634 9.375 10.9375C9.375 9.21161 10.7741 7.8125 12.5 7.8125C14.2259 7.8125 15.625 9.21161 15.625 10.9375Z"
				:stroke="color"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M20.3125 10.9375C20.3125 18.3772 12.5 22.6562 12.5 22.6562C12.5 22.6562 4.6875 18.3772 4.6875 10.9375C4.6875 6.62278 8.18528 3.125 12.5 3.125C16.8147 3.125 20.3125 6.62278 20.3125 10.9375Z"
				:stroke="color"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgPin',
	props: {
		color: {
			type: String,
			default: '',
		},
		size: {
			type: Number,
			default: null,
		},
		strokeColor: {
			type: String,
			default: null,
		},
		strokeWidth: {
			type: Number,
			default: 1,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>
